import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import metadata from './RecentAccountPaymentTable.metadata.json5';
import styles from './RecentAccountPaymentTable.module.scss';
import messages from './RecentAccountPaymentTable.messages';


const renderFormattedCurrencyField = (item, index) => {
    return (
        <div className={styles.currencyContainer}>
            <CurrencyField
                id={`currency_${index}`}
                value={item}
                readOnly
                hideLabel
            />
        </div>
    );
};

const getFormattedCurrency = (item, index, property) => {
    return renderFormattedCurrencyField(item[property.id]);
};

const getCell = (item, index, property) => {
    if(item[property.id]==="Reversed")
    {
        return (
            <div className={styles.reverseComment}>
                {item[property.id]}
            </div>
        )
           
    }
    return item[property.id];
};

function RecentAccountPaymentTable(props) {
    const {
        invoiceSummary,
        showPaidDate,
        showSelect
    } = props;

    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback((item, index, property) => {
        return  moment(item[property.id]).format('MM/DD/YYYY');
        
    } );

    

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: invoiceSummary
        },
        tablePaymentScheduleDetailLastPaymentDate: {
            visible: showPaidDate
        },
        tablePaymentScheduleDetailPay: {
            visible: showSelect
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getFormattedCurrency,
            getCell,
            
        }
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />;
}

RecentAccountPaymentTable.propTypes = {
    invoiceSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedInvoices: PropTypes.arrayOf(PropTypes.string),
    onUpdateSelectedInvoices: PropTypes.func,
    showSelect: PropTypes.bool,
    showPaidDate: PropTypes.bool
};

RecentAccountPaymentTable.defaultProps = {
    selectedInvoices: [],
    onUpdateSelectedInvoices: undefined,
    showSelect: false,
    showPaidDate: false
};

export default RecentAccountPaymentTable;
